import VoiceTextarea from "../VoiceTextarea";
import { TrendingUp, TrendingDown, Minus, AlertCircle, CheckCircle2 } from "lucide-react";

const CATEGORIES = [
  { key: "better", label: "Better", icon: TrendingDown, accent: "text-sage-600", placeholder: "What's improved since last visit?" },
  { key: "worse", label: "Worse", icon: TrendingUp, accent: "text-terracotta-600", placeholder: "What's regressed?" },
  { key: "unchanged", label: "Unchanged", icon: Minus, accent: "text-ink-500", placeholder: "Anything still the same?" },
  { key: "new_symptoms", label: "New symptoms", icon: AlertCircle, accent: "text-amber-700", placeholder: "Anything new the client mentioned today?" },
  { key: "resolved_symptoms", label: "Resolved", icon: CheckCircle2, accent: "text-sage-700", placeholder: "What fully resolved?" },
];

/**
 * "Progress since last visit" widget — five short text fields with optional voice input.
 * Shown on NewSession capture phase when a previous completed session exists.
 */
export default function ProgressSinceLast({ progress, onChange, onBlurSave }) {
  const update = (key, value) => onChange({ ...progress, [key]: value });

  return (
    <div className="bg-white border border-paper-200 rounded-3xl p-6 sm:p-8" data-testid="progress-since-last">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div>
          <div className="label-overline mb-1 text-sage-700">Progress since last visit</div>
          <h2 className="font-heading text-lg text-ink-900">How is the client compared to last time?</h2>
        </div>
        <span className="text-xs text-ink-500">AI compares findings against this</span>
      </div>
      <p className="text-sm text-ink-700 mb-5">
        Skip any that don't apply. Tap the mic on any field to dictate.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {CATEGORIES.map(({ key, label, icon: Icon, accent, placeholder }) => (
          <div key={key} data-testid={`progress-${key}`}>
            <div className="flex items-center gap-2 mb-2">
              <Icon className={`w-3.5 h-3.5 ${accent}`} strokeWidth={1.75} />
              <span className="label-overline">{label}</span>
            </div>
            <VoiceTextarea
              value={progress?.[key] || ""}
              onChange={(v) => update(key, v)}
              onBlur={onBlurSave}
              rows={2}
              placeholder={placeholder}
              testId={`progress-${key}-input`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
